<template>
  <component
    :is="hasChildren ? 'el-submenu' : 'el-menu-item'"
    :index="menuIndex"
  >
    <template v-if="hasChildren" slot="title">
      <menu-title :item="item" />
    </template>
    <menu-title v-if="!hasChildren" :item="item" />
    <template v-if="hasChildren">
      <sidebar-item
        v-for="child in visibleChildren"
        :key="resolveMenuIndex(child)"
        :item="child"
        :node-key="`${nodeKey}/${resolveMenuIndex(child)}`"
      />
    </template>
  </component>
</template>

<script>
import { hasLayoutChildren, resolveMenuIndex } from '@/layout/utils/menu-nav'

export default {
  name: 'SidebarItem',
  components: {
    MenuTitle: {
      props: ['item'],
      template: `
        <div class="menu-title">
          <img v-if="iconUrl" class="menu-icon-img" :src="iconUrl" alt="" />
          <i v-else-if="iconClass" :class="iconClass"></i>
          <i v-else class="el-icon-menu default-menu-icon"></i>
          <span class="menu-title-text">{{ item.meta.title }}</span>
        </div>
      `,
      computed: {
        iconUrl() {
          const icon = this.item.meta && this.item.meta.icon
          return icon && (icon.indexOf('http') === 0 || icon.indexOf('/') === 0) ? icon : ''
        },
        iconClass() {
          const icon = this.item.meta && this.item.meta.icon
          if (!icon || this.iconUrl) return ''
          return icon.indexOf('el-icon') === 0 ? icon : `iconfont ${icon}`
        },
      },
    },
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    nodeKey: {
      type: String,
      default: '',
    },
  },
  computed: {
    menuIndex() {
      if (!this.hasChildren) return resolveMenuIndex(this.item)
      return this.nodeKey || `group-${resolveMenuIndex(this.item)}`
    },
    visibleChildren() {
      return (this.item.children || []).filter((c) => c.meta && c.meta.layout == 1)
    },
    hasChildren() {
      return hasLayoutChildren(this.item)
    },
  },
  methods: {
    resolveMenuIndex,
  },
}
</script>

<style scoped lang="less">
.menu-title {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
}
.menu-icon-img {
  width: 18px;
  height: 18px;
  margin-right: 8px;
  object-fit: contain;
}
.default-menu-icon {
  margin-right: 8px;
  font-size: 16px;
}
::v-deep .el-menu--collapse .menu-title-text {
  display: none;
}
</style>
